import { MyWeddnChecklist } from "../../components/dashboard/MyWeddnChecklist";
import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { Routes } from "../../routes/baseRoutes";
import "./my-weddn.css";
import MyWeddnV2 from "../../components/dashboard/MyWeddnV2";
import { useFeatureFlag } from "../../hooks/useFeatureFlag";
import { useCallback, useState } from "react";

const MyWeddn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { enabled: v2Enabled, loading: flagLoading } = useFeatureFlag("my_weddn_v2");
  const [progress, setProgress] = useState({ completed: 0, total: 0 });
  const progressPercent = Math.round((progress.completed / Math.max(progress.total, 1)) * 100);
  const handleProgress = useCallback((completed: number, total: number) => setProgress({ completed, total }), []);

  const goBack = () => {
    if (location.key !== "default") navigate(-1);
    else navigate(Routes.dashboard);
  };

  return (
    <main className="my-weddn-page relative mx-auto w-full max-w-3xl px-4 pb-28 pt-6 md:px-8 md:pb-12 md:pt-10">
      <button
        type="button"
        onClick={goBack}
        aria-label="Go back"
        className="absolute -left-10 top-10 hidden h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 transition hover:border-slate-300 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 lg:flex"
      >
        <ArrowLeft size={18} />
      </button>
      <div className="my-weddn-page__intro mb-7">
        <div className="flex items-end justify-between gap-5">
          <div>
            <p className="mb-2 text-xs uppercase tracking-[0.22em] text-slate-500">Your wedding plan</p>
            <h1 className="text-3xl font-medium text-slate-950 md:text-4xl">My Weddn</h1>
          </div>
          {v2Enabled && !flagLoading && <div className="mb-1 w-36 shrink-0 sm:w-48" aria-label={`${progress.completed} of ${progress.total} wedding tasks complete`}>
            <div className="mb-2 flex items-baseline justify-between gap-3"><span className="text-xs text-slate-500">{progress.completed} of {progress.total}</span><span className="text-sm font-medium text-slate-700">{progressPercent}%</span></div>
            <div className="h-1.5 overflow-hidden rounded-full bg-slate-200"><div className="h-full rounded-full bg-[#4f9665] transition-all" style={{ width: `${progressPercent}%` }} /></div>
          </div>}
        </div>
        <p className="mt-3 max-w-xl text-sm leading-6 text-slate-600 md:text-base">{v2Enabled ? "Plan together with your partner and event planner. Every update stays in one shared workspace." : "Keep the important details in one place. Some tasks update automatically as you use Weddn, and you can check off, edit, or add the rest."}</p>
      </div>
      <section>
        {flagLoading ? <div className="py-10 text-center text-sm text-slate-500">Loading your wedding plan…</div> : v2Enabled ? <MyWeddnV2 showProgress={false} onProgress={handleProgress} /> : <MyWeddnChecklist />}
      </section>
    </main>
  );
};

export default MyWeddn;
